/**
 * Main App Entry Point
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress "message port closed" errors from Chrome extensions (e.g. Google Translate,
// Grammarly, ad blockers) that inject content scripts into the page.
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason &&
    typeof event.reason.message === 'string' &&
    event.reason.message.includes('message port closed')
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
